import React from "react";
import { LuAlertCircle } from "react-icons/lu";
import { ErrorValidations } from "../../enums-lists/Validations";

interface InputProps extends React.SelectHTMLAttributes<HTMLSelectElement>{  
  label?: string | undefined  
  values?: Array<{name: string, value: number | string}> | undefined
  error?: string | undefined
  onChange?: (evt: React.ChangeEvent<HTMLSelectElement>) => void
  showempty?: string | undefined  
}
interface InputState
{
  error?: string | undefined
}

class InputSelect extends React.Component<InputProps, InputState> {
  state = { error: ''}
  onclick = (evento: React.MouseEvent<HTMLSelectElement>): void =>{
  if (parseInt(evento.currentTarget.value)>0){
    this.setState({ error: ''})}
  else{
    this.setState({ error: ErrorValidations.Required})}     
  } 
  render() {
    return (
      <div className={this.props.className}>
        {this.props.label &&
          <label className={this.props.className + '-label'}>
            {this.props.label}
          </label>
        }
        <select
          {...this.props}          
          onClick={this.onclick}  
          className={this.props.className + ((this.props.error) ? '-red' : '-grey')}
        >
          { this.props.showempty &&
            <option key='-1' value={"-1"}></option>
          }
          {this.props.values?.map((estadoCobranza, index) => 
            <option key={'s' + index} value={estadoCobranza.value}>{estadoCobranza.name}</option>
          )}          
        </select>
        <label className={this.props.className + '-error'}>
          {(this.props.error || (this.state.error && this.props.required)) &&
            <div>
              <LuAlertCircle className="cobranza-filter-alert-circlet"/>
              {(this.props.error || this.state.error)}
            </div>
          }
        </label>
      </div>      
    );
  }
}

export default InputSelect;